import appConfig from 'app.config'
import { useTranslation } from 'react-i18next'

export const CashToAccountForm = () => {
	const { t } = useTranslation()

	return {
		fieldSetName: '',
		formName: 'CashToAccountForm',
		description: '',
		collapsable: false,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'ibanDE',
				type: 'text',
				label: t('CashToAccountIban'),
				visible: true,
				col: 12,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '\\b^BE\\d{14}\\b$|\\b^BG\\s?[a-zA-Z0-9]{20}\\b$|\\b^DK\\d{16}\\b$|\\b^DE\\d{20}\\b$|\\b^EE\\d{18}\\b$|\\b^FI\\d{16}\\b$|\\b^GR\\d{25}\\b$|\\b^IE\\s?[a-zA-Z0-9]{20}\\b$|\\b^IT\\s?[a-zA-Z0-9]{25}\\b$|\\b^HR\\d{19}\\b$|\\b^LV\\s?[a-zA-Z0-9]{19}\\b$|\\b^LU\\d{18}\\b$|\\b^MT\\s?[a-zA-Z0-9]{29}\\b$|\\b^NL\\s?[a-zA-Z0-9]{16}\\b$|\\b^AT\\d{18}\\b$|\\b^PL\\d{26}\\b$|\\b^PT\\d{26}\\b$|\\b^RO\\s?[a-zA-Z0-9]{22}\\b$|\\b^SE\\d{22}\\b$|\\b^SK\\d{22}\\b$|\\b^SI\\d{17}\\b$|\\b^ES\\d{22}\\b$|\\b^CZ\\d{22}\\b$|\\b^HU\\d{26}\\b$|\\b^CY\\d{26}\\b$',
						message: t('ValidationMsgSddIban'),
					},
				],
			},
			{
				required: true,
				controlName: 'amount',
				type: 'number',
				label: t('CashToAccountAmount'),
				visible: true,
				col: 12,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '\\b^([5-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]|10000)\\b$',
						message: t('ValidationMsgSddAmount'),
					},
				],
			},
			{
				required: true,
				controlName: 'termsAndConditions',
				type: 'checkbox',
				label: `<a href="https://tfbank.de/media/1smppbim/agb-sofortgeld.pdf" target="_blank" >
						${t('CashToAccountTermsAndConditions')}
					</a>`,
				visible: true,
				col: 12,
			},
		],
	}
}
